/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/iframe-has-title */
import { ThemeProvider } from '@emotion/react'
import isUndefined from 'lodash/isUndefined'
import { FC, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useMount } from 'react-use'

import { FORM_TYPE_IDS, FormTypeId } from '~/common/constants/formTypes'
import { THEME } from '~/form/constants'

import PageForm from './page/PageForm'
import PageThanks from './page/PageThanks'
import {
  setClientId,
  setFormType,
  setPage,
  setFormName,
  setEmploymentStatus,
} from './redux/formSlice'
import { WorkerFormStorage } from './types'

type Props = {
  clientId?: string
  formType?: string
  formName?: string
  employmentStatus?: string
}

const ORIGIN = 'https://worker.mei-kyu.com'

const isValidFormType = (formType: string) =>
  (FORM_TYPE_IDS as ReadonlyArray<string>).includes(formType)

const App: FC<Props> = ({ clientId, formType, formName, employmentStatus }) => {
  const dispatch = useDispatch()

  const [error, setError] = useState<string>()

  const [workerFormValues, setWorkerFormValues] = useState<WorkerFormStorage>()

  const reduxPage = useSelector((state) => state.form.page)

  useMount(() => {
    if (isUndefined(formType) || !isValidFormType(formType)) {
      setError('フォームタイプが不正です')

      return
    }
    if (!isUndefined(clientId)) {
      dispatch(setClientId(clientId))
    }
    if (!isUndefined(formName)) {
      dispatch(setFormName(formName))
    }
    if (!!employmentStatus) {
      dispatch(setEmploymentStatus(employmentStatus))
    }
    dispatch(setFormType(formType as FormTypeId))
    dispatch(setPage('input'))

    window.addEventListener('message', (event) => {
      // 送信元が指定のオリジンと一致していれば処理を行う
      if (event.origin === ORIGIN) {
        // console.log(event.data)
        const storageData: WorkerFormStorage = event.data.body
        console.log('storageData', storageData)
        if (storageData) {
          setWorkerFormValues({
            lastName: storageData.lastName || '',
            firstName: storageData.firstName || '',
            mailAddress: storageData.mailAddress || '',
            resumeUrl: storageData.resumeUrl || '',
            selfPr: storageData.selfPr || '',
            skillSheetUrl: storageData.skillSheetUrl || '',
          })
        }
      }
    })

    const iframe: HTMLIFrameElement = document.querySelector('#iframe')!
    iframe.addEventListener('load', () => {
      const iframeWindow = iframe.contentWindow
      if (iframeWindow) {
        iframeWindow.postMessage('GET', ORIGIN)
      }
    })
  })

  if (!isUndefined(error)) return <div>{error}</div>

  if (isUndefined(reduxPage)) return null

  return (
    <ThemeProvider theme={THEME}>
      <>
        {reduxPage === 'thanks' ? (
          <PageThanks />
        ) : (
          <PageForm workerFormValues={workerFormValues} />
        )}
      </>
    </ThemeProvider>
  )
}

export default App
